<template>
  <div>
    <!-- <v-select
      v-model="actualPrinter"
      :options="printers"
      class="margin-multi sp-border-input bg-white w-25 mb-2"
      placeholder="Impresora"
    />-->
    <CRow>
      <CCol sm="12" class="p-0">
        <CCard>
          <div class="px-3 flex-column flex-md-row py-2 d-flex justify-content-between w-100 border-bottom align-items-center">
            <h5>Análisis</h5>
            <div class="d-flex align-items-center justify-content-center flex-wrap flex-sm-nowrap">
              <DateSelector initDates="week" @input="e => changeDate(e)" class="margi-dates" />
            </div>
          </div>
          <CCardBody class="p-0 pt-2">
            <CNav justified variant="tabs">
              <CNavItem :to="{name: 'Analisis'}">Análisis por ubicación</CNavItem>
              <CNavItem :to="{name: 'AnalisisNomina'}">Análisis de nómina</CNavItem>
              <CNavItem :to="{name: 'AnalisisEficiencia'}" active>Análisis de eficiencia</CNavItem>
            </CNav>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CButtonGroup class="mb-2">
      <CButton @click="changeAnalisis(1)" color="primary">Trabajadores</CButton>
      <CButton @click="changeAnalisis(2)" color="primary">Ubicaciones</CButton>
    </CButtonGroup>
    <v-select v-model="actividad" :options="actividades" :loading="isLoadingPage" @input="changeCombo()" class="p-0 mb-3" placeholder="Selecciona una actividad">
      <template #open-indicator="{ attributes }">
        <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
      </template>
      <template #no-options>Sin resultados.</template>
    </v-select>
    <CRow v-if="actividad">
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold padding-sm d-flex sp-flex justify-content-between text-sm align-items-center catalogo-text">Análisis por eficiencia</CCardHeader>
          <div class="table-responsive">
            <table v-if="actualAnalisis == 1" class="table mb-0">
              <thead>
                <tr>
                  <th class="custom-width-space" scope="col">{{ "" }}</th>
                  <th class="custom-width-space" scope="col">Cantidad</th>
                  <th class="custom-width-space" scope="col">Unidad</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr v-if="isLoading || requests.length > 1"> -->
                <tr v-if="isLoading">
                  <td colspan="5">
                    <div class="w-100 d-flex justify-content-center align-items-center">
                      <div class="sk-flow d-flex align-items-center">
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 1 && !isLoading" class="d-table-row">
                  <td class="py-2 cursor-p custom-width-space" @click="toggleHeaders(1)">
                    <span>
                      <CIcon name="cil-chevron-circle-down-alt" />
                    </span>
                    Trabajadores
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    {{ totalAct.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">{{ unidad }}</td>
                </tr>
                <tr v-if="actualAnalisis == 1 && !isLoading" class="d-table-row ml-4">
                  <td class="m-0 p-0" colspan="5">
                    <CCollapse :show="headersDetails.includes(1)">
                      <CDataTable bordered small fixed class="mb-0" addTableClasses="mb-0" :header="false" :loading="isLoading" :items="itemsEgresos" :fields="fields" :noItemsView="noItems">
                        <template #nombre="{item, index}">
                          <td class="custom-width-space" :class="`${items.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0 ? `cursor-p` : ``}`" @click="toggleUbicaciones(index, 1)">
                            <span>
                              <CIcon v-if="items.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0" name="cil-chevron-circle-down-alt" />
                            </span>
                            {{ item.payload.nombre }}
                          </td>
                        </template>
                        <template #total="{item}">
                          <td class="custom-width-space" :class="`${items.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0 ? `cursor-p` : ``}`" @click="toggleUbicaciones(index, 1)">
                            {{ item.total.replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                          </td>
                        </template>
                        <template #unidad="{item}">
                          <td class="custom-width-space" :class="`${items.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0 ? `cursor-p` : ``}`" @click="toggleUbicaciones(index, 1)">{{ item.unidad }}</td>
                        </template>
                      </CDataTable>
                    </CCollapse>
                  </td>
                </tr>
              </tbody>
            </table>

            <table v-if="actualAnalisis == 2" class="table mb-0">
              <thead>
                <tr>
                  <th class="custom-width-space" scope="col">{{ "" }}</th>
                  <th class="custom-width-space" scope="col">Cantidad</th>
                  <th class="custom-width-space" scope="col">Unidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isLoading">
                  <td colspan="5">
                    <div class="w-100 d-flex justify-content-center align-items-center">
                      <div class="sk-flow d-flex align-items-center">
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 2 && !isLoading" class="d-table-row">
                  <td class="cursor-p custom-width-space" @click="toggleHeaders(2)">
                    <span>
                      <CIcon name="cil-chevron-circle-down-alt" />
                    </span>
                    Total
                  </td>
                  <td @click="toggleTotal(2)" class="custom-width-space cursor-p">
                    {{ totalAct.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                  </td>
                  <td @click="toggleTotal(2)" class="custom-width-space cursor-p">{{ unidad }}</td>
                </tr>
                <tr v-if="actualAnalisis == 2 && !isLoading" class="d-table-row ml-4">
                  <td class="m-0 p-0" colspan="5">
                    <CCollapse :show="headersDetails.includes(2)">
                      <CDataTable bordered small fixed class="mb-0" addTableClasses="mb-0" :header="false" :loading="isLoading" :items="filteredItems" :fields="fields" :noItemsView="noItems">
                        <template #nombre="{item, index}">
                          <td class="custom-width-space" :class="`${itemsLocations.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0 ? `cursor-p` : ``}`" @click="toggleUbicaciones(index, 1)">
                            <span>
                              <CIcon v-if="itemsLocations.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0" name="cil-chevron-circle-down-alt" />
                            </span>
                            {{ item.payload.nombre }}
                          </td>
                        </template>
                        <template #total="{item}">
                          <td class="custom-width-space" :class="`${itemsLocations.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0 ? `cursor-p` : ``}`" @click="toggleUbicaciones(index, 1)">
                            {{ item.total.replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                          </td>
                        </template>
                        <template #unidad="{item}">
                          <td class="custom-width-space" :class="`${itemsLocations.filter(hijo => hijo.payload.pertenece_id == item.id).length > 0 ? `cursor-p` : ``}`" @click="toggleUbicaciones(index, 1)">{{ item.unidad }}</td>
                        </template>
                        <template v-if="!filter" #details="{item}">
                          <CCollapse :show="details.find(item => item.type == 1) ? true : false">
                            <!-- <CCardBody class="py-0 px-0 pl-2"> -->
                            <table-collapse @click-cancel="toggleCancel" @click-print="printNanoid" :ubicacionPadre="item.id" :cultivos="cultivos" :ubicaciones="getTableLocations(item, 2)"></table-collapse>
                          </CCollapse>
                        </template>
                      </CDataTable>
                    </CCollapse>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCard>
      </CCol>
    </CRow>
    <h2 v-else class="text-center">Selecionar una actividad.</h2>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DateSelector from "../../../customComponents/DateSelector";
import moment from "moment";
import axios from "axios";

const fields = [
  { key: "nombre", _style: "width:33%" },
  { key: "total", _style: "width:33%" },
  { key: "unidad", _style: "width:33%" }
];

const fieldsHeaders = [
  { key: "name", label: "", _style: "width:20%" },
  { key: "Cubeta serie", label: "Labores", _style: "width:20%" },
  { key: "Unidad", label: "Productos", _style: "width:20%" },
  { key: "gastos", label: "Gastos", _style: "width:20%" },
  { key: "total", label: "Total", _style: "width:20%" }
];

import TableCollapse from "../../../customComponents/TableCollapseQuantity";

export default {
  name: "AnalisisEficiencia",

  components: {
    TableCollapse,
    vSelect,
    DateSelector
  },

  data() {
    return {
      requests: [],
      request: null,
      items: [],
      itemsLocations: [],
      itemsProduccion: [],
      itemsIngresos: [],
      itemsEgresos: [],
      cultivos: [],
      fields,
      fieldsHeaders,
      filter: "",
      dropdownCustom: false,
      allSelections: false,
      cancelModal: false,
      details: [],
      actualAnalisis: 1,
      actividad: null,
      actividades: [],
      actividadesAll: [],
      detailEgresos: [],
      detailProduccion: [],
      headersDetails: [],
      totalDetails: [],
      totalAct: 0,
      isLoading: false,
      isLoadingPage: false,
      printModal: false,
      cancelSource: null,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      itemModalPrint: { cantidadCopias: 1 },
      itemModal: { id: "", name: "", index: "" },
      unidad: "",
      totalTrabajador: {
        name: "",
        hora: "",
        horaExtra: "",
        variable: "",
        total: ""
      },
      totalProduccion: {
        name: "",
        labores: "",
        productos: "",
        gastos: "",
        total: ""
      },
      headersItems: [
        {
          name: "Egresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Ingresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Producción",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        }
      ],
      egresosTotal: [
        {
          name: "Total",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Ingresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Producción",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        }
      ]
    };
  },

  created() {
    this.getInfoCombos();
  },

  computed: {
    printers() {
      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
      // ? { value: window.printerAct.uid, label: window.printerAct.name }
      // : null;
    },
    filteredItems() {
      return this.itemsIngresos.filter(i => i.payload.pertenece_id == 0);
      // .filter(i =>
      //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
      // );
    },
    filteredItemsIngresos() {
      return this.itemsIngresos.filter(i => i.payload.pertenece_id == 0);
    },
    filteredItemsProduccion() {
      return this.itemsProduccion.filter(i => i.payload.pertenece_id == 0);
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    datesGraph() {
      return this.$store.state.dateGraphs;
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.searchTimeOut();
    },
    actualAnalisis: function() {
      // this.searchTimeOut();
    },
    datesGraph: function() {
      this.searchTimeOut();
    },
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.changeCombo();
      }, 800);
    },
    onClickPrintCodes() {
      this.printModal = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: false };
            })
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: true };
            })
          : [];
        this.allSelections = true;
      }
    },
    printItems() {
      const idsToPrint = this.items.filter(item => item.selected === true);

      idsToPrint.length
        ? idsToPrint.map(ubicacion => {
            this.printNanoid(ubicacion, this.itemModalPrint.cantidadCopias);
          })
        : null;

      this.printModal = false;
    },
    printNanoid(ubicacion, cant) {
      if (ubicacion && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${ubicacion.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${ubicacion.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.filter(
        cultivo => cultivo.id == cultivo_id
      );

      return cultivoActual[0].payload.nombre;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    toggleUbicaciones(index, type) {
      const item = { index: index, type: type };

      const position = this.details.findIndex(item => item.type == type);

      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(item);
    },
    toggleTotal(index) {
      const position = this.totalDetails.indexOf(index);
      position !== -1
        ? this.totalDetails.splice(position, 1)
        : this.totalDetails.push(index);
    },
    toggleHeaders(index) {
      const position = this.headersDetails.indexOf(index);
      position !== -1
        ? this.headersDetails.splice(position, 1)
        : this.headersDetails.push(index);
    },
    deleteUbicacion(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "ubicaciones",
          id: id
        })
        .then(res => {
          // console.log(res.data);
        })
        .catch(rej => {
          // console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    },
    getInfoCombos() {
      const ubicacionTemplateRaiz = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaizValue,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      const ubicacionTemplateNoRaiz = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      const call = [
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",

          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
              },
              {
                field: "payload->suspendido",
                operator: "=",
                value: false
              }
            ]
          }
        }),
        this.$store.dispatch("customHTTP", { schema: "actividades" })
      ];

      if (this.ubicacionRaizValue) {
        call.push(...ubicacionTemplateRaiz);
      } else {
        call.push(...ubicacionTemplateNoRaiz);
      }

      this.isLoadingPage = true;
      Promise.all(call)
        .then(([trabajadores, actividades, ubicaciones]) => {
          // console.log(trabajadores.data);
          // console.log(actividades.data);
          this.actividades = actividades.data.map(actividad => {
            return { value: actividad.id, label: actividad.payload.nombre };
          });
          this.actividadesAll = actividades.data;
          this.items = trabajadores.data;
          this.itemsLocations = ubicaciones.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    updateAllInfo() {
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      this.request = { cancel: this.cancelSource.cancel, msg: "Loading..." };

      const call = [
        this.$store.dispatch("customIndicadoresHTTPEf", {
          body: {
            reporte: "labores_trabajador_analisis",
            params: {
              fecha: this.datesGraph,
              ubicaciones: [this.ubicacionRaizValue],
              actividad_id: this.actividad.value
            }
          },
          cancelToken: this.cancelSource
        }),
        this.$store.dispatch("customIndicadoresHTTP", {
          body: {
            reporte: "labores_ubicacion_analisis",
            params: {
              fecha: this.datesGraph,
              ubicaciones: [this.ubicacionRaizValue],
              actividad_id: this.actividad.value
            }
          },
          cancelToken: this.cancelSource
        })
      ]

      this.isLoading = true;
      const actualUnidad = this.actividadesAll.find(
        act => act.id == this.actividad.value
      );
      this.unidad = actualUnidad.payload.unidad;

      Promise.all(call).then(([eficiencia, ubicaciones]) => {
        this.requests.push(eficiencia)
        this.func(actualUnidad, eficiencia)

        this.itemsIngresos = this.itemsLocations.map(ubi => {
          const actualIndicator = ubicaciones.data.find(
            item => item.ubicacion == ubi.payload.nombre
          );

          if (!ubi.payload.cultivo_id) {
            const hojas = ubicaciones.data.filter(item =>
              item.ubicacion_ruta
                .split("/")
                .includes(ubi.payload.nombre)
            );
            const totalRama = hojas.reduce(
              (acum, item) => (acum += item.cantidad),
              0
            );
            return {
              ...ubi,
              total: totalRama ? `${totalRama.toFixed(2)}` : "0",
              unidad: actualUnidad.payload.unidad,
              selected: false
            };
          } else {
            return {
              ...ubi,
              total: actualIndicator
                ? `${actualIndicator.cantidad.toFixed(2)}`
                : "0",
              unidad: actualUnidad.payload.unidad
            };
          }
        })

        this.totalAct = eficiencia.data.reduce((acum, item) => {
          acum += item.cantidad;
          return acum;
        }, 0);

        this.isLoading = false;

        this.isLoading = false;
      })
      .catch(err => {
        this.logResponseErrors
        if (err !== "Stop") {
          this.isLoading = false;
        }
      });
    },
    findItems(requests) {
      let item = null
      for (let index = 0; index < this.requests.length; index++) {
        const element = this.requests[index];
        if (JSON.stringify(element.fecha) === JSON.stringify(this.datesGraph)) {
          item = element
          break
        }
      }
      return item
    },
    func(actualUnidad, eficiencia) {
      this.isLoading = true;
      let mostrando = this.findItems(this.requests)
      this.itemsEgresos = this.items.map(tra => {
        const actualTrabajador = eficiencia.data.find(
          item => item.trabajador == tra.payload.nombre
        );

        return {
          ...tra,
          total: actualTrabajador
            ? `${actualTrabajador.cantidad.toFixed(2)}`
            : "0",
          unidad: actualUnidad.payload.unidad
        };
      })

      this.totalAct = mostrando.data.reduce((acum, item) => {
        acum += item.cantidad;
        return acum;
      }, 0);
    },
    getTableLocations(item, type) {
      if (type == 1) {
        return this.itemsEgresos.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      } else if (type == 2) {
        return this.itemsIngresos.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      } else {
        return this.itemsProduccion.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      }
    },
    changeAnalisis(value) {
      if (value) {
        this.actualAnalisis = value;
      }
    },
    changeCombo() {
      if (this.actividad) {
        this.updateAllInfo();
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Stop");
        // console.log("cancel requesst done");
      }
    },
    changeDate(e) {
      // console.log(e);
      const datesValues = [
        moment(e.start).format("YYYY-MM-DD"),
        moment(e.end).format("YYYY-MM-DD")
      ];
      this.$store.dispatch("setDateGraph", datesValues);
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.layout {
  table-layout: fixed;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  /* width: 50%;
  white-space: nowrap; */
}
.custom-width-space {
  /* display: table-cell; */
  width: 33% !important;
}
.custom-width-td {
  width: 70%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100%;
}
.sp-border-input {
  border-radius: 4px;
}
.sp-flex {
  flex-direction: row;
}
.sp-margin-b {
  margin-bottom: 0;
}
.sp-width-butom {
  width: 160px;
}
.cursor-p {
  cursor: pointer;
}

@media (max-width: 768px) {
  .sp-flex {
    flex-direction: column;
  }
  .sp-margin-b {
    margin-bottom: 0.8rem;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
